import { APP_CONFIG } from 'src/config.app'
import { WorkflowItem } from 'src/models/dto/ActivityDTO'
import { ADAxios, ApiActionNames } from 'src/services/AxiosInterceptor'

/** One captured look-and-feel for an item type, with short-lived presigned image URLs. */
export interface LookAndFeelSummary {
    signatureHash: string
    realImageUrl?: string
    templateImageUrl?: string
}

interface GetItemLookAndFeelsResponse {
    lookAndFeels?: LookAndFeelSummary[]
}

interface GetItemLookAndFeelPageResponse {
    pageJson: string
}

/**
 * Client for the look-and-feel gallery APIs on RxtHofAuthoringService. The gallery lets an author
 * browse the distinct look-and-feels captured for an item type and drop one into their module as a
 * new page.
 */
export class LookAndFeelService {
    public static async getItemLookAndFeels(
        itemType: string,
        abortController?: AbortController
    ): Promise<LookAndFeelSummary[]> {
        const { data }: { data: GetItemLookAndFeelsResponse } = await ADAxios.get(
            `${APP_CONFIG.backendAPIBaseUrl}/item-look-and-feels/${encodeURIComponent(itemType)}`,
            {
                apiActionName: ApiActionNames.GetItemLookAndFeels,
                signal: abortController?.signal,
            }
        )
        return data.lookAndFeels ?? []
    }

    /** Fetches the scrubbed page's moduleChild for one look-and-feel, ready to wrap in an ActivityDTO. */
    public static async getItemLookAndFeelPage(
        itemType: string,
        signatureHash: string,
        abortController?: AbortController
    ): Promise<WorkflowItem> {
        const { data }: { data: GetItemLookAndFeelPageResponse } = await ADAxios.get(
            `${APP_CONFIG.backendAPIBaseUrl}/item-look-and-feels/${encodeURIComponent(
                itemType
            )}/${encodeURIComponent(signatureHash)}/page`,
            {
                apiActionName: ApiActionNames.GetItemLookAndFeelPage,
                signal: abortController?.signal,
            }
        )
        return JSON.parse(data.pageJson) as WorkflowItem
    }
}
